import { render } from "./ModifyLoginPassword.vue?vue&type=template&id=033e5fa8&scoped=true"
import script from "./ModifyLoginPassword.vue?vue&type=script&lang=js"
export * from "./ModifyLoginPassword.vue?vue&type=script&lang=js"

import "./ModifyLoginPassword.vue?vue&type=style&index=0&id=033e5fa8&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033e5fa8"]])

export default __exports__